import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Обновляем состояние, чтобы отобразить резервный интерфейс
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Логируем ошибку (например, отправляем на сервер)
    //console.error("Caught by ErrorBoundary:", error, errorInfo);
    //this.setState({ error, errorInfo });
    return;
    fetch("https://api.inua.com.ua/api/logs/catch", {
      method: "POST",
      headers: {
        "Content-Type": "application/json", // Заголовки, указывающие тип данных
      },
      body: JSON.stringify({ error: `${error}`, errorInfo, component: 'manager' }), // Данные в формате JSON
    })

  }

  render() {
    /*
    if (this.state.hasError) {
      return (
        <div>
          <h1>Что-то пошло не так.</h1>
          <details style={{ whiteSpace: "pre-wrap" }}>
            {this.state.error && this.state.error.toString()}
            <br />
            {this.state.errorInfo?.componentStack}
          </details>
        </div>
      );
    }
    */
    return this.props.children;
  }
}

export default ErrorBoundary;
